import { defineMessages } from "react-intl";

const messages = defineMessages({
    copied: {
        id: "input.copiedToTheClipboard",
    },
});

export default messages;
